@if (data) {
  <div class="content-center">
    <input type="checkbox" [(ngModel)]="checkboxValue" (change)="onChange()" />
  </div>
}
